export default "__VITE_ASSET__C8npNs1i__"